module.exports = __webpack_public_path__ + "img/bars-sort.410e18da.svg";